export default __webpack_public_path__ + "static/media/Group8880.e7cdc374.svg";